import { deburr } from 'lodash';

export const metaFilterToOptions = (
  source: string[] | { [key: string]: string | undefined } | null | undefined
): { label: string; value: string }[] => {
  if (source === null || source === undefined) {
    return [];
  }
  if (Array.isArray(source)) {
    return source.map((type) => ({ label: type, value: deburr(type) }));
  }
  return Object.entries(source).map(([key, val]) => ({
    label: val ?? key,
    value: key,
  }));
};
